/* eslint-disable react-refresh/only-export-components */
import type {ReactElement} from 'react';
import type {EmailMakerControl, EmailMakerControlProps} from '../../right-panel-registry.types';
import {createDescriptorControl} from '../create-descriptor-control';
import {SingleCtaButton} from './components/single-cta-button/single-cta-button';
import type {CtaButtonDescriptor, CtaButtonGroupDescriptor} from './cta-button-control.types';
import styles from './cta-button-control.module.scss';

interface CtaButtonControlInnerProps extends EmailMakerControlProps {
  descriptor: CtaButtonGroupDescriptor;
}

function CtaButtonControlInner({component, descriptor}: CtaButtonControlInnerProps): ReactElement {
  return (
    <div className={`flex-v-row ${styles.buttonGroup}`}>
      {descriptor.buttons.map((btn: CtaButtonDescriptor) => (
        <SingleCtaButton btn={btn} component={component} key={btn.textKey} />
      ))}
    </div>
  );
}

export function makeCtaButtonControl(descriptor: CtaButtonGroupDescriptor): EmailMakerControl {
  return createDescriptorControl(CtaButtonControlInner, descriptor);
}
